module.exports = __webpack_public_path__ + "img/mushamaru_2.276c5d2a.png";